import React, {useEffect, useState} from "react";
import {NumericFormat} from 'react-number-format';
import SideNav from "../layout/sidenav";
import NavBar from "../layout/navbar";
import Footer from "../layout/footer";
import {
    Button,
    Input,
    Dialog,
    DialogBody,
    DialogFooter,
    DialogHeader,
    Typography,
    Tabs,
    TabsHeader,
    TabsBody,
    Tab,
    TabPanel,
    Select,
    Option,
    Tooltip,
} from "@material-tailwind/react";
import {
    PrinterIcon,
    ExclamationTriangleIcon,
    ChevronDownIcon,
    ChevronRightIcon,
    PencilIcon
} from "@heroicons/react/24/solid";
import InputMask from "react-input-mask";
import CardSelection from "../shared/card_selection";
import MapComponent from "../shared/map_component";
import payment from "../ux/pages/payment";
import axios, {Axios} from "axios";

const Payments = ({routes, username, role}) => {
    const [openSidenav, setOpenSidenav] = useState(false);

    const [step, setStep] = useState(1);
    const [searchType, setSearchType] = useState("search_by_name");
    const [viewType, setViewType] = useState('yearly');
    const [clavePredio, setClavePredio] = useState("");
    const [name, setName] = useState("");
    const [pLastName, setPLastName] = useState("");
    const [mLastName, setMLastName] = useState("");
    const [selectedYAdeudos, setSelectedYAdeudos] = useState([]);
    const [selectedBAdeudos, setSelectedBAdeudos] = useState([]);
    const [invoices, setInvoices] = useState([]);
    const [paymentMethod, setPaymentMethod] = useState("");
    const [recibido, setRecibido] = useState(0);
    const [contributors, setContributors] = useState(null);
    const [selectedContributor, setSelectedContributor] = useState(null);
    const [lots, setLots] = useState([]);
    const [predio, setPredio] = useState(null);
    const [error, setError] = useState(null);
    const [adeudos, setAdeudos] = useState(null);
    const [requiresReview, setRequiresReview] = useState(false);

    const [openResetDialog, setOpenResetDialog] = useState(false);
    const [openWarningDialog, setOpenWarningDialog] = useState(false);
    const [openEndDialog, setOpenEndDialog] = useState(false);
    const [openInvoicesDialog, setOpenInvoicesDialog] = useState(false);

    const [cards, setCards] = useState([
        {id: "1", last4: "1234"},
        {id: "2", last4: "5678"},
    ]);
    const [selectedCard, setSelectedCard] = useState(null);

    const paymentTabs = [
        {label: "Efectivo", value: "E"},
        {label: "Tarjeta", value: "T"},
        {label: "Cheque", value: "C"},
        {label: "Depósito", value: "D"},
    ];

    const totalSelected = selectedBAdeudos.reduce(
        (acc, adeudo) => acc + adeudo.total,
        0
    );
    const totalSelectedRounded = Math.ceil(totalSelected);

    /*    useEffect(() => {
            if (clavePredio) {
                loadDebts();
            }
        }, [clavePredio]);*/

    const handleBuscar = async () => {
        setError(null);
        setPredio(null);
        setLots([]);
        setSelectedContributor(null);

        if (searchType === "search_by_cve") {
            if (clavePredio.trim() === "") return setError("Ingrese una clave válida");

            await handleSelectPredio(clavePredio);
        } else if (searchType === "search_by_name") {
            if (name.trim() === "" && pLastName.trim() === "" && mLastName.trim() === "") return alert("Ingrese un nombre válido");

            try {
                const response = await fetch(`/lots/search_by_name?name=${name}&parental_last_name=${pLastName}&maternal_last_name=${mLastName}`);

                if (!response.ok) {
                    setError("No se encontraron contribuyentes.");
                    setStep(1);
                    return;
                }

                const data = await response.json();
                setContributors(data);
            } catch (err) {
                console.error("Error al buscar el predio:", err);
            }
        }
    };

    const handleGetLotsByContributor = async (contributorId) => {
        try {
            const response = await fetch(`/lots/search_by_contributor?id=${contributorId}`);
            const data = await response.json();
            setLots(data);
            setSelectedContributor(contributorId);
        } catch (err) {
            console.error("Error fetching lots:", err);
        }
    };

    const fetchInvoices = async () => {
        try {
            const response = await fetch(`related_invoices/${clavePredio}`);
            const data = await response.json();
            setInvoices(data);
        } catch (error) {
            console.error("Error fetching invoices:", error);
        }
    };

    const handleOpenModal = () => {
        setOpenInvoicesDialog(true);
        fetchInvoices();
    };

    const handleReprint = (invoiceId) => {
        window.open(`/print_ticket/${invoiceId}`, "_blank");
    };

    const handleSelectLot = async (lot) => {
        setClavePredio(lot.parcel_code);
        setPredio(lot)
        setStep(2);
    };

    const handleReset = () => {
        setStep(1);
        setRecibido(0);
        setClavePredio("");
        setSelectedBAdeudos([]);
        setSelectedYAdeudos([]);
        setPaymentMethod("");
        setName("");
        setPLastName("");
        setMLastName("");
        setOpenResetDialog(false);
        setLots([]);
        setAdeudos(null);
        setError(null);
        setContributors(null);
        setSelectedContributor(null);
        setPredio(null);
        setRequiresReview(false);
        setOpenEndDialog(false);
    };

    const handleModifySelection = () => {
        setSelectedCard(null);
        setPaymentMethod("");
        setRecibido(0);
        setStep(2);
    };

    const toggleAdeudo = (adeudo) => {
        setSelectedBAdeudos((prev) => {
            const isSelected = prev.some((item) => item.id === adeudo.id);

            if (isSelected) {
                return prev.filter((item) => item.id_debt < adeudo.id_debt);
            } else {
                const affectedAdeudos = adeudos.filter(
                    (item) => item.id_debt <= adeudo.id_debt
                );
                return [...affectedAdeudos];
            }
        });
    };


    const handleContinue = () => {
        if (selectedBAdeudos.length === 0) {
            setOpenWarningDialog(true);
        } else {
            setStep(3);
        }
    };

    const addCard = (cardData) => {
        // API llamada a tokenizar tarjeta
        const newCard = {
            id: (cards.length + 1).toString(),
            last4: cardData.cardNumber.slice(-4),
        };
        setCards([...cards, newCard]);
    };

    const handlePayment = async () => {
        const debtsIds = selectedBAdeudos.map(item => item.id);
        try {
            const response = await axios.post(`payments/${clavePredio}/debt.json`, {
                charged: totalSelectedRounded,
                debts: debtsIds,
                paymentType: paymentMethod
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 200) {
                window.open(`/print_ticket/${response.data.id}`, '_blank');

                setOpenEndDialog(true);
            }
        } catch (err) {
            setError('Error al iniciar sesión. Verifica tus credenciales.');
        }
    };

    const calculateChange = () => (recibido - totalSelectedRounded).toFixed(2);
    const calculateYearlyTotals = (debts) => {
        return debts.reduce((acc, adeudo) => {
            const year = adeudo.year;
            if (!acc[year]) {
                acc[year] = {
                    year: year,
                    tax: 0,
                    university_tax: 0,
                    surcharge: 0,
                    subtotal: 0,
                    discount: 0,
                    total: 0,
                };
            }
            acc[year].tax += adeudo.tax;
            acc[year].university_tax += adeudo.university_tax;
            acc[year].surcharge += adeudo.surcharge;
            acc[year].subtotal += adeudo.subtotal;
            acc[year].discount += adeudo.discount;
            acc[year].total += adeudo.total;
            return acc;
        }, {});
    };

    const handleSelectPredio = async (parcel_code) => {
        setClavePredio(parcel_code);

        try {
            const [lotsResponse, debtsResponse] = await Promise.all([
                fetch(`/lots/${parcel_code}/search_by_code.json`),
                fetch(`/lots/${parcel_code}/debts.json`)
            ]);

            if (!lotsResponse.ok) {
                setError("No se encontraron datos para este código.");
                setStep(1);
                return;
            } else {

            }
            const lotsData = await lotsResponse.json();
            setPredio(lotsData);

            if (debtsResponse.ok) {
                const debtsData = await debtsResponse.json();

                setAdeudos(debtsData);
                setSelectedBAdeudos(debtsData);

                const yearlyData = Object.values(calculateYearlyTotals(debtsData));
                setSelectedYAdeudos(yearlyData);
            } else {
                console.log("No se encontraron datos para este código.");
            }

        } catch (err) {
            console.error("Error al buscar el predio:", err);
        }

        setStep(2);
    };

    const handleToggleReview = async () => {
        try {
            const response = await fetch(`/lots/${clavePredio}/requires_review`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                console.log("Error toggle requires review");
            }

            const data = await response.json();
            setPredio({
                ...predio,
                requires_review: data.requires_review
            })
        } catch (error) {
            console.error("Error toggle requires review: ", error);
        }
    };

    const handleDeleteDiscount = async () => {
        try {
            const response = await fetch(`/discount_lots/${predio.discount_lot_id}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                throw new Error(`Error HTTP: ${response.status}`);
            } else {
                await handleSelectPredio(clavePredio);

            }

            console.log("Registro eliminado correctamente.");
        } catch (error) {
            console.error("Error al eliminar el registro:", error);
        }

    };

    return (
        <>
            {/*<SideNav setOpenSidenav={setOpenSidenav} openSidenav={openSidenav} roleKey={role}/>
            <div className="p-4 xl:ml-80">
                {/*<NavBar
                    routes={routes}
                    setOpenSidenav={setOpenSidenav}
                    openSidenav={openSidenav}
                    userName={username}
                />*/}
                <div className="min-w-screen min-h-screen pb-5">
                    <div className="w-full bg-white border-gray-200 px-5 py-10 text-gray-800">
                        {step === 1 && (
                            <>
                                <h6 className="font-semibold uppercase text-gray-600 mb-4">
                                    PAGO DE PREDIAL
                                </h6>
                                <div className="mb-6">
                                    <div className="flex gap-4 items-center bg-gray-100 p-4 rounded">
                                        <span className="text-lg font-bold whitespace-nowrap pr-4">Búsqueda por:</span>
                                        <Select
                                            value={searchType}
                                            onChange={(e) => setSearchType(e)}
                                            className="w-full"
                                        >
                                            <Option value="search_by_cve">Clave catastral</Option>
                                            <Option value="search_by_name">Nombre y Apellidos</Option>
                                        </Select>
                                    </div>
                                    <div className="mt-4 bg-white p-6 rounded shadow-md">
                                        {searchType === "search_by_cve" && (
                                            <section id="find_by_cve">
                                                <div
                                                    className="flex justify-between md:items-center gap-y-4 flex-col md:flex-row">
                                                    <div>
                                                        <h1 className="font-bold text-lg">BUSQUEDA POR PREDIO</h1>
                                                        <p className="text-sm text-gray-500">
                                                            Ingresa la clave catastral para buscar.
                                                        </p>
                                                        {error && <p style={{color: "red"}}>{error}</p>}
                                                    </div>
                                                    <div className="flex gap-2">
                                                        <div className="lg:w-96">

                                                            <InputMask
                                                                mask="519999-999-999"
                                                                value={clavePredio}
                                                                onChange={(e) => setClavePredio(e.target.value)}
                                                            >
                                                                {(inputProps) => (
                                                                    <input
                                                                        {...inputProps}
                                                                        type="text"
                                                                        placeholder="51XXXX-XXX-XXX"
                                                                        className="p-2 w-full border border-gray-300 rounded"
                                                                    />
                                                                )}
                                                            </InputMask>
                                                        </div>
                                                        <Button onClick={handleBuscar}>Buscar</Button>
                                                    </div>
                                                </div>
                                            </section>
                                        )}
                                        {searchType === "search_by_name" && (
                                            <>
                                                <section id="find_by_name">
                                                    <div
                                                        className="flex justify-between md:items-center gap-y-4 flex-col md:flex-row">
                                                        <div>
                                                            <h1 className="font-bold text-lg">BUSQUEDA POR NOMBRE</h1>
                                                            <p className="text-sm text-gray-500">
                                                                Ingresa los datos del predio para buscar.
                                                            </p>
                                                            {error && <p style={{color: "red"}}>{error}</p>}
                                                        </div>
                                                        <div className="flex flex-wrap gap-2 items-center">
                                                            <input
                                                                type="text"
                                                                placeholder="Nombre"
                                                                className="p-2 w-28 md:w-36 border border-gray-300 rounded uppercase"
                                                                value={name}
                                                                onChange={(e) => setName(e.target.value.toUpperCase())}
                                                            />
                                                            <input
                                                                type="text"
                                                                placeholder="Apellido Paterno"
                                                                className="p-2 w-28 md:w-36 border border-gray-300 rounded uppercase"
                                                                value={pLastName}
                                                                onChange={(e) => setPLastName(e.target.value.toUpperCase())}
                                                            />
                                                            <input
                                                                type="text"
                                                                placeholder="Apellido Materno"
                                                                className="p-2 w-28 md:w-36 border border-gray-300 rounded uppercase"
                                                                value={mLastName}
                                                                onChange={(e) => setMLastName(e.target.value.toUpperCase())}
                                                            />
                                                            <Button onClick={handleBuscar}>Buscar</Button>
                                                        </div>
                                                    </div>
                                                </section>
                                            </>
                                        )}
                                    </div>
                                    {searchType === "search_by_name" && contributors && (
                                        <div className="mt-8">
                                            {contributors.length > 0 ? (
                                                <div>
                                                    <h6 className="font-semibold uppercase text-gray-600 mb-4">
                                                        Resultados de búsqueda
                                                    </h6>

                                                    <ul className="border p-4 rounded-md bg-white shadow">
                                                        {contributors.map((contributor, index) => (
                                                            <li key={contributor.id}
                                                                className={`${index === contributors.length - 1 ? "" : "border-b"}`}>
                                                                <div
                                                                    className="flex justify-between items-center py-3 px-4 rounded-md cursor-pointer hover:bg-blue-gray-50 transition duration-200"
                                                                    onClick={() => handleGetLotsByContributor(contributor.id)}
                                                                >
                                                                    <span className="text-gray-700 font-medium">
                                                                        <strong>
                                                                          {contributor.name} {contributor.parental_last_name} {contributor.maternal_last_name}
                                                                        </strong>
                                                                    </span>
                                                                    {selectedContributor === contributor.id ? (
                                                                        <ChevronDownIcon
                                                                            className="h-5 w-5 text-gray-700"/>
                                                                    ) : (
                                                                        <ChevronRightIcon
                                                                            className="h-5 w-5 text-gray-500"/>
                                                                    )}
                                                                </div>
                                                                {selectedContributor === contributor.id && (
                                                                    <ul className="p-4 mt-2 bg-blue-gray-500/20 rounded-md">
                                                                        {lots.length > 0 ? (
                                                                            lots.map((lot, index) => (
                                                                                <li
                                                                                    key={`${lot.parcel_code}-${index}`}
                                                                                    className={`flex justify-between items-center py-2 px-3 rounded-md cursor-pointer hover:bg-gray-100 transition duration-200 hover:bg-brown-500/10 ${index === lots.length - 1 ? "" : "border-b border-blue-gray-50"}`}
                                                                                    onClick={() => handleSelectPredio(lot.parcel_code)}
                                                                                >
                                                                                  <span className="text-gray-600">
                                                                                    <strong>{lot.parcel_code}</strong>: {`${lot.road_name}${lot.ext_num ? ' #' + lot.ext_num : ''}, ${lot.neighborhood_name}`}
                                                                                  </span>
                                                                                </li>
                                                                            ))
                                                                        ) : (
                                                                            <li className="text-gray-500 italic">No se
                                                                                encontraron <strong>predios.</strong>
                                                                            </li>
                                                                        )}
                                                                    </ul>
                                                                )}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            ) : (
                                                <div>
                                                    <h6 className="font-semibold uppercase text-gray-600 my-4 text-center">
                                                        No se encontraron coincidencias.
                                                    </h6>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </>
                        )}


                        {step !== 1 && (
                            <>
                                <h6 className="font-semibold uppercase text-gray-600 mb-2">
                                    PAGO DE PREDIAL
                                </h6>
                                <div className="bg-white p-5 border rounded-md mb-4">
                                    <div className="flex justify-between items-center">
                                        <div>
                                            <h6 className="font-semibold">Clave Buscada:</h6>
                                            <p>{clavePredio}</p>
                                        </div>
                                        <Button
                                            size="sm"
                                            className="mt-2 bg-red-700"
                                            onClick={() => setOpenResetDialog(true)}
                                            style={{marginLeft: 'auto'}}
                                        >
                                            Restablecer
                                        </Button>
                                    </div>

                                    <Dialog open={openResetDialog} handler={setOpenResetDialog}>
                                        <DialogHeader>Confirmación</DialogHeader>
                                        <DialogBody>¿Estás seguro de restablecer?</DialogBody>
                                        <DialogFooter>
                                            <Button
                                                variant="text"
                                                onClick={() => setOpenResetDialog(false)}
                                                className="mr-2"
                                            >
                                                Cancelar
                                            </Button>
                                            <Button
                                                className="bg-red-500 text-white"
                                                onClick={handleReset}
                                            >
                                                Confirmar
                                            </Button>
                                        </DialogFooter>
                                    </Dialog>
                                </div>
                            </>
                        )}

                        {step === 2 && (
                            <div>
                                <h6 className="font-semibold uppercase text-gray-600 mt-8">
                                    Información del predio
                                </h6>
                                <div className="flex flex-col lg:flex-row gap-4 min-h-[350px]">
                                    <div className="flex-grow border p-4 rounded-md w-full lg:w-1/2">
                                        {predio && (
                                            <table className="w-full min-w-max table-auto text-left">
                                                <tbody>
                                                <tr>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-bold"
                                                        >
                                                            Tipo de Predio:
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            className="font-normal text-gray-600"
                                                        >
                                                            {predio.lot_location_type}
                                                        </Typography>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-bold"
                                                        >
                                                            Propietario:
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            className="font-normal text-gray-600"
                                                        >
                                                            {predio.name} {predio.parental_last_name} {predio.maternal_last_name}
                                                        </Typography>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-bold"
                                                        >
                                                            Dirección:
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            className="font-normal text-gray-600"
                                                        >
                                                            {predio.road_name}{predio.ext_num ? " #" + predio.ext_num : ""}, {predio.neighborhood_name},
                                                            C.P. {predio.postal_code}
                                                        </Typography>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-bold"
                                                        >
                                                            Referencias:
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            className="font-normal text-gray-600"
                                                        >
                                                            {predio.address_references === null ? '' : predio.address_references}
                                                        </Typography>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-bold"
                                                        >
                                                            Sup. Terreno:
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            className="font-normal text-gray-600"
                                                        >
                                                            {predio.land_area.toFixed(2)}
                                                        </Typography>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-bold"
                                                        >
                                                            Sup. Const:
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography
                                                            variant="small"
                                                            className="font-normal text-gray-600"
                                                        >
                                                            {predio.construction_area.toFixed(2)}
                                                        </Typography>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        )}
                                        {predio.discount_lot_id && (
                                            <Button
                                                size="sm"
                                                className={`mt-2 flex items-center btn-review-active bg-red-700`}
                                                onClick={handleDeleteDiscount}
                                                style={{marginLeft: 'auto'}}
                                            >
                                                {"Eliminar Descuento"}
                                            </Button>
                                        )}
                                        <Button
                                            size="sm"
                                            className={`mt-2 flex items-center ${predio.requires_review ? "btn-review-active bg-red-700" : "bg-amber-500"}`}
                                            onClick={handleToggleReview}
                                            style={{marginLeft: 'auto'}}
                                            disabled={predio.requires_review}
                                        >
                                            {predio.requires_review ? "Marcado para revisión" : "Marcar para revisión"}
                                        </Button>
                                    </div>
                                    <div className="flex-grow border rounded-md w-full lg:w-1/2 min-h-[350px]">
                                        {predio.latitude && predio.longitude ? (
                                            <MapComponent
                                                parcel_code={clavePredio}
                                                latitude={predio.latitude}
                                                longitude={predio.longitude}
                                            />
                                        ) : (
                                            <MapComponent/>
                                        )}
                                    </div>
                                </div>

                                <div className="flex justify-between items-center mt-8">
                                    <h6 className="font-semibold uppercase text-gray-600">
                                        Adeudos
                                    </h6>

                                    <div className="flex items-center space-x-2">
                                        <Button
                                            size="sm"
                                            className="bg-amber-500 flex items-center mx-2"
                                            onClick={() => {
                                                window.open("/print_debts/" + clavePredio);
                                            }}
                                        >
                                            Estado de cuenta
                                        </Button>

                                        <Button
                                            size="sm"
                                            className="bg-blue-gray-500 flex items-center mx-2"
                                            onClick={handleOpenModal}
                                        >
                                            Reimprimir tickets
                                        </Button>
                                    </div>
                                </div>

                                <Dialog open={openInvoicesDialog} handler={() => setOpenInvoicesDialog(false)}>
                                    <DialogHeader>Facturas Anteriores</DialogHeader>
                                    <DialogBody
                                        className="max-h-60 overflow-y-auto [&::-webkit-scrollbar-thumb]:rounded-xl [&::-webkit-scrollbar-thumb]:bg-slate-300 [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:rounded-xl [&::-webkit-scrollbar-track]:bg-slate-100">
                                        {invoices.length > 0 ? (
                                            <table className="min-w-full w-full table-auto border-collapse">
                                                <thead>
                                                <tr>
                                                    <th className="py-2 px-4 text-left font-semibold">Fecha</th>
                                                    <th className="py-2 px-4 text-left font-semibold">Estatus</th>
                                                    <th className="py-2 px-4 text-left font-semibold">Total</th>
                                                    <th className="py-2 px-4 text-right font-semibold"></th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {invoices.map(({id, created_at, status, total}) => (
                                                    <tr key={id} className="border-b">
                                                        <td className="py-2 px-4 font-bold">{new Date(created_at).toISOString().split('T')[0]}</td>
                                                        <td className="py-2 px-4 font-bold">{status}</td>
                                                        <td className="py-2 px-4">
                                                            <NumericFormat
                                                                value={total.toFixed(2)}
                                                                displayType={'text'}
                                                                prefix={'$'}
                                                                allowLeadingZeros
                                                                thousandSeparator=","
                                                            />
                                                        </td>
                                                        <td className="py-2 px-4 flex justify-end">
                                                            <Button
                                                                size="sm"
                                                                color="blue-gray"
                                                                onClick={() => handleReprint(id)}
                                                            >
                                                                <PrinterIcon className="w-5 h-5"/>
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <Typography color="gray">No se encontraron facturas.</Typography>
                                        )}
                                    </DialogBody>
                                    <DialogFooter>
                                        <Button color="red" onClick={() => setOpenInvoicesDialog(false)}>
                                            Cerrar
                                        </Button>
                                    </DialogFooter>
                                </Dialog>

                                <table className="w-full min-w-[640px] table-auto">
                                    <thead>
                                    <tr>
                                        {["", "Año", "Bimestre", "Impuesto", "Imp. Univ.", "Recargos", "Subtotal", "Descuento", "Total"].map(
                                            (el) => (
                                                <th
                                                    key={el}
                                                    className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                >
                                                    <Typography
                                                        variant="small"
                                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                    >
                                                        {el}
                                                    </Typography>
                                                </th>
                                            )
                                        )}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {(!adeudos || adeudos.length === 0) ? (
                                        <Typography
                                            variant="normal"
                                            color="blue-gray"
                                            className="font-bold text-center"
                                        >
                                            El predio no tiene adeudos.
                                        </Typography>
                                    ) : (adeudos.map((adeudo, index) => {
                                            const className = `py-3 px-5 ${
                                                index === adeudos.length - 1 ? "" : "border-b border-blue-gray-50"
                                            }`;
                                            const disabled = index === 0;
                                            return (
                                                <tr key={adeudo.id} className="hover:bg-gray-50 cursor-pointer">
                                                    <td className={className}>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedBAdeudos.some(
                                                                (item) => item.id === adeudo.id
                                                            )}
                                                            onChange={() => toggleAdeudo(adeudo)}
                                                            disabled={disabled}
                                                        />
                                                    </td>
                                                    <td className={className}>{adeudo.year}</td>
                                                    <td className={className}>{adeudo.bimester}</td>
                                                    <td className={className}>${adeudo.tax.toFixed(2)}</td>
                                                    <td className={className}>${adeudo.university_tax.toFixed(2)}</td>
                                                    <td className={className}>${adeudo.surcharge.toFixed(2)}</td>
                                                    <td className={className}>${adeudo.subtotal.toFixed(2)}</td>
                                                    <td className={className}>
                                                        <Tooltip content={`${adeudo.discount_percentage}%`} placement="right">
                                                            <span>${adeudo.discount.toFixed(2)}</span>
                                                        </Tooltip>
                                                    </td>
                                                    <td className={className}>${(adeudo.total).toFixed(2)}</td>
                                                </tr>
                                            );
                                        })
                                    )}
                                    </tbody>
                                </table>

                                {(adeudos && adeudos.length > 0) && (
                                    <div className="mt-8 w-full flex justify-end">
                                        <div className="md:w-4/12 w-full">
                                            <div className="w-full p-6 mb-2 rounded-lg shadow-lg"
                                                 style={{backgroundColor: '#33277a'}}>
                                                <div className="flex justify-between text-white text-xl font-semibold">
                                                    <span className="font-bold text-sm">Redondeo:</span>
                                                    <span>${(Math.ceil(totalSelected) - totalSelected).toFixed(2)}</span>
                                                </div>
                                                <div className="flex justify-between text-white text-xl font-semibold">
                                                    <span className="font-bold text-sm">Total a pagar:</span>
                                                    <span><NumericFormat
                                                        value={totalSelectedRounded.toFixed(2)}
                                                        displayType={'text'}
                                                        prefix={'$'}
                                                        allowLeadingZeros
                                                        thousandSeparator=","
                                                    /></span>
                                                </div>
                                            </div>
                                            <Button
                                                className="bg-gray-500 text-white rounded-md px-8 py-3 text-lg w-full hover:scale-110 transition-colors duration-300"
                                                onClick={handleContinue}
                                            >
                                                CONTINUAR
                                            </Button>
                                        </div>
                                    </div>
                                )}
                                <Dialog open={openWarningDialog} handler={setOpenWarningDialog}>
                                    <DialogHeader>Advertencia</DialogHeader>
                                    <DialogBody>
                                        <Typography>
                                            Por favor, selecciona al menos un adeudo para continuar con el pago.
                                        </Typography>
                                    </DialogBody>
                                    <DialogFooter>
                                        <Button
                                            className="bg-blue-500 text-white"
                                            onClick={() => setOpenWarningDialog(false)}
                                        >
                                            Aceptar
                                        </Button>
                                    </DialogFooter>
                                </Dialog>
                            </div>
                        )}

                        {step === 3 && (
                            <div>
                                <h6 className="flex font-semibold uppercase text-gray-600">
                                    Confirmar pago
                                </h6>

                                <div className="flex items-center justify-between mb-4">
                                    <div>
                                        <Button
                                            size="sm"
                                            onClick={() => setViewType('yearly')}
                                            className={`px-4 py-2 ${viewType === 'yearly' ? 'bg-blue-500' : 'bg-blue-gray-50  text-blue-gray-300'}`}
                                        >
                                            Anual
                                        </Button>
                                        <Button
                                            size="sm"
                                            onClick={() => setViewType('bimestral')}
                                            className={`mr-2 px-4 py-2 ${viewType === 'bimestral' ? 'bg-blue-500' : 'bg-blue-gray-50 text-blue-gray-300'}`}
                                        >
                                            Bimestral
                                        </Button>
                                    </div>
                                    <Button
                                        size="sm"
                                        className="mt-2 bg-amber-500 flex items-center"
                                        onClick={handleModifySelection}
                                        style={{marginLeft: 'auto'}}
                                    >
                                        <PencilIcon className="w-5 h-5 mr-2"/>
                                        Modificar selección
                                    </Button>
                                </div>

                                <table className="w-full min-w-[640px] table-auto">
                                    <thead>
                                    <tr>
                                        {[
                                            viewType === 'bimestral' && "Bimestre",
                                            "Año",
                                            "Impuesto",
                                            "Imp. Univ.",
                                            "Recargos",
                                            "Subtotal",
                                            "Descuento",
                                            "Total"
                                        ].filter(Boolean).map((el) => (
                                            <th key={el} className="border-b border-blue-gray-50 py-3 px-6 text-left">
                                                <Typography variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400">
                                                    {el}
                                                </Typography>
                                            </th>
                                        ))}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {(viewType === 'bimestral' ? selectedBAdeudos : selectedYAdeudos).map((adeudo, index) => {
                                        const className = `py-3 px-5 ${index % 2 ? 'bg-gray-50' : ''}`;
                                        return (
                                            <tr key={adeudo.year + (viewType === 'bimestral' ? adeudo.bimester : '')}>
                                                {viewType === 'bimestral' &&
                                                    <td className={className}>{adeudo.bimester}</td>}
                                                <td className={className}>{adeudo.year}</td>
                                                <td className={className}>${adeudo.tax.toFixed(2)}</td>
                                                <td className={className}>${adeudo.university_tax.toFixed(2)}</td>
                                                <td className={className}>${adeudo.surcharge.toFixed(2)}</td>
                                                <td className={className}>${adeudo.subtotal.toFixed(2)}</td>
                                                <td className={className}>${adeudo.discount.toFixed(2)}</td>
                                                <td className={className}>${adeudo.total.toFixed(2)}</td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </table>

                                <div className="flex flex-col md:flex-row md:gap-8">
                                    <div className="md:w-8/12 w-full px-5">
                                        <h6 className="font-semibold uppercase text-gray-600 mt-8 mb-2">
                                            Método de pago
                                        </h6>

                                        <Tabs value={paymentTabs}>
                                            <TabsHeader>
                                                {paymentTabs.map(({label, value}) => (
                                                    <Tab key={value} value={value}
                                                         onClick={() => setPaymentMethod(value)}>
                                                        {label}
                                                    </Tab>
                                                ))}
                                            </TabsHeader>
                                            <TabsBody>
                                                <TabPanel key='E' value='E'>
                                                    <div className="mt-4">
                                                    <div className="flex gap-4">
                                                            <div className="w-full">
                                                                <label htmlFor="recibido"
                                                                       className="block text-sm font-medium text-gray-700 mb-1">Cantidad
                                                                    recibida</label>
                                                                <input
                                                                    id="recibido"
                                                                    className="w-full px-3 py-2 border border-gray-200 rounded-md"
                                                                    placeholder="Cantidad recibida"
                                                                    type="text"
                                                                    value={recibido}
                                                                    onChange={(e) => setRecibido(Number(e.target.value))}
                                                                />
                                                            </div>

                                                            <div className="w-full">
                                                                <label
                                                                    className="block text-sm font-medium text-gray-700 mb-1">Cobrado</label>
                                                                <div
                                                                    className="w-full px-3 py-2 border border-gray-200 rounded-md">
                                                                    ${totalSelectedRounded.toFixed(2)}
                                                                </div>
                                                            </div>

                                                            <div className="w-full">
                                                                <label
                                                                    className="block text-sm font-medium text-gray-700 mb-1">Cambio</label>
                                                                <div
                                                                    className="w-full px-3 py-2 border border-gray-200 rounded-md">
                                                                    ${calculateChange()}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>

                                                <TabPanel key='T' value='T'>
                                                    {//DISABLED CARD SECTION
                                                        false ? (
                                                            <CardSelection
                                                                cards={cards}
                                                                onCardSelect={setSelectedCard}
                                                                onAddCard={addCard}
                                                            />
                                                        ) : (
                                                            <div className="mt-4">
                                                                <div className="border p-4 rounded-md">
                                                                    <p>Total a cobrar: <strong>${totalSelectedRounded.toFixed(2)}</strong>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        )}
                                                </TabPanel>

                                                <TabPanel key='C' value='C'>
                                                    <div className="mt-4">
                                                        <div className="border p-4 rounded-md">
                                                            <p>Total a
                                                                cobrar: <strong>${totalSelectedRounded.toFixed(2)}</strong>
                                                            </p>
                                                        </div>

                                                        <div className="w-full">
                                                            <label htmlFor="recibido" className="block text-sm font-medium text-gray-700 mb-1">
                                                                Imagen de cheque e identificación
                                                            </label>
                                                            <input
                                                                id="recibido"
                                                                className="w-full px-3 py-2 border border-gray-200 rounded-md"
                                                                placeholder="Cantidad recibida"
                                                                type="file"
                                                            />
                                                        </div>
                                                    </div>
                                                </TabPanel>

                                                <TabPanel key='D' value='D'>
                                                    <div className="mt-4">
                                                        <div className="border p-4 rounded-md">
                                                            <p>Total a
                                                                cobrar: <strong>${totalSelectedRounded.toFixed(2)}</strong>
                                                            </p>
                                                        </div>

                                                        <div className="w-full">
                                                            <label htmlFor="recibido" className="block text-sm font-medium text-gray-700 mb-1">
                                                                Comprobante de pago
                                                            </label>
                                                            <input
                                                                id="recibido"
                                                                className="w-full px-3 py-2 border border-gray-200 rounded-md"
                                                                placeholder="Cantidad recibida"
                                                                type="file"
                                                            />
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                            </TabsBody>
                                        </Tabs>
                                    </div>

                                    <div className="md:w-4/12 w-full flex justify-end mt-16">
                                        <div className="w-full">
                                            <div className="w-full p-6 mb-2 rounded-lg shadow-lg"
                                                 style={{backgroundColor: '#33277a'}}>
                                                <div className="flex justify-between text-white text-xl font-semibold">
                                                    <span className="font-bold text-sm">Redondeo:</span>
                                                    <span>${(Math.ceil(totalSelected) - totalSelected.toFixed(2)).toFixed(2)}</span>
                                                </div>
                                                <div className="flex justify-between text-white text-xl font-semibold">
                                                    <span className="font-bold text-sm">Total a pagar:</span>
                                                    <span><NumericFormat
                                                        value={totalSelectedRounded.toFixed(2)}
                                                        displayType={'text'}
                                                        prefix={'$'}
                                                        allowLeadingZeros
                                                        thousandSeparator=","
                                                    /></span>
                                                </div>
                                            </div>
                                            <Button
                                                disabled={paymentMethod === ''}
                                                className="bg-green-500 text-white w-full rounded-md px-8 py-3 text-lg hover:scale-110 "
                                                onClick={() => handlePayment()}
                                            >
                                                PAGAR
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                                <Dialog open={openEndDialog} handler={openEndDialog}>
                                    <DialogHeader>Advertencia</DialogHeader>
                                    <DialogBody>
                                        <Typography>
                                            Pago realizado con éxito
                                        </Typography>
                                    </DialogBody>
                                    <DialogFooter>
                                        <Button
                                            className="bg-red-500 text-white"
                                            onClick={() => handleReset()}
                                        >
                                            Finalizar
                                        </Button>
                                    </DialogFooter>
                                </Dialog>
                            </div>
                        )}
                    </div>
                </div>
            {/*<Footer/>
            </div>*/}
        </>
    );
};

export default Payments;


